"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AppStateConstants_1 = require("../../types/AppStateConstants");
const localStorageDeleteAllData = ({ callbacks, executeProcesses, store, }) => {
    store.dispatch({
        type: AppStateConstants_1.AppStateConstants.LOCAL_STORAGE_CLEAN_DATA,
    });
    executeProcesses(undefined, callbacks.success);
};
exports.default = localStorageDeleteAllData;
